(function () {

  'use strict';

  angular.module('History')

    .constant('RESOUCRE_FILTER',
      {
        SYSTEM: 'TENANT,GROUP_SYNCHRONIZATION,CLOUD_STORAGE_ACCOUNT,DATA_EXTRACT,DATA_EXTRACT_JOB_DEFINITION,DATA_ACCESS_ACCOUNT,GROUP,NETWORK,IDENTITY_PROVIDER,IDENTITY_PROVIDER_DIRECTORY,SITE,ONDEVICE_CONFIGS,SOFTWARE',
        PRINTERS: 'PRINTER,PRINTER_QUEUE',
        WORKSTATIONS: 'WORKSTATION',
        USERS: 'USER',
        DOCUMENTS: 'PRINT_JOB,SCAN'
      }
    )

    .controller('HistoryController', function (
      $scope, EventHandlerService, currentTenant, RESOUCRE_FILTER) {

      $scope.tenant = currentTenant;
      $scope.resourceFilters = RESOUCRE_FILTER;
      $scope.helpCaption = 'HelpHistoryPage';
      $scope.eventHandlerService = EventHandlerService;

      (function () {
        initEventHandler();
      })();

      function initEventHandler() {
        $scope.eventHandlerService.deRegisterListeners();
      }

    });
})();
